import { INVITE_STATUS } from "./inviteStatus"

export const INVITE_STATUS_BADGE_VARIANTS = {
  [INVITE_STATUS.PENDING]: "waiting",
  [INVITE_STATUS.ACCEPTED]: "success",
  [INVITE_STATUS.DECLINED]: "error",
  [INVITE_STATUS.NOT_INVITED]: "locked",
  [INVITE_STATUS.CANCELLED]: "locked",
}
